/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_3Inputs */

const en_gc_search_guides_gridcraft_online_sections_2_steps_3 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reopen the saved copy through File → Open and check the edited cell and a dependent total. Only close the session after you have a file with the changes you expect.`)
};

const zh_gc_search_guides_gridcraft_online_sections_2_steps_3 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过 File → Open 重新打开保存的副本，检查修改的单元格和相关合计。确认文件包含预期修改后，再关闭会话。`)
};

/**
* | output |
* | --- |
* | "Reopen the saved copy through File → Open and check the edited cell and a dependent total. Only close the session after you have a file with the changes you ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_2_steps_3 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_2_steps_3(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_2_steps_3(inputs)
});
export { gc_search_guides_gridcraft_online_sections_2_steps_3 as "gc.search_guides.gridcraft_online.sections.2.steps.3" }